module.exports = __webpack_public_path__ + "static/media/sliderArrowLeft.6c3bd51c.svg";